import { render, staticRenderFns } from "./FeedbackInfo.vue?vue&type=template&id=2b7ac89a"
import script from "./FeedbackInfo.vue?vue&type=script&lang=js"
export * from "./FeedbackInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports